var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 71,
    viewBox: "0 0 40 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4514 30.9926L38.6062 31.2344C39.4835 32.6057 39.9987 34.2311 39.9987 35.9797C39.9987 37.7283 39.4835 39.3533 38.6062 40.7248L38.4514 40.9673L19.302 71H0L31.9763 20.8375L38.4514 30.9926Z",
    fill: "url(#paint0_linear_640_26166)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4514 40.9681L38.6062 40.726C39.4835 39.3546 39.9987 37.7295 39.9987 35.9809C39.9987 34.2324 39.4835 32.6069 38.6062 31.2357L38.4514 30.9938L19.302 0.960499H0L31.9763 51.123L38.4514 40.9681Z",
    fill: "#EF3620"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_26166",
    x1: -3.97363,
    y1: 64.7677,
    x2: 41.4998,
    y2: 35.7728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794511,
    stopColor: "#B32422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B32422"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.52e43a2d721b7c7b3f3bec13e2cc5d65.svg";
export { ForwardRef as ReactComponent };